import React from 'react';
import { WalletIcon, MenuIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="w-full bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="flex justify-between items-center h-16" data-id="element-205">
          <div className="flex items-center gap-2" data-id="element-206">
            <div className="bg-emerald-500 p-1.5 rounded-lg" data-id="element-207">
              <WalletIcon className="h-6 w-6 text-white" data-id="element-208" />
            </div>
            <span className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-209">
              ClubAhorra
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-210">
            <a href="#beneficios" className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-211">
              Beneficios
            </a>
            <a href="#como-funciona" className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-212">
              Cómo funciona
            </a>
          </div>

          <div className="md:hidden" data-id="element-213">
            <button className="p-2 text-gray-600 hover:bg-gray-50 rounded-md" data-id="element-214">
              <MenuIcon className="h-6 w-6" data-id="element-215" />
            </button>
          </div>
        </div>
      </div>
    </nav>;
}